'use strict';
import 'rxjs/add/operator/delay';
import React, {Component} from 'react';
import {getFilterDataFromListState} from '../../../../_libs/redux-observable-list';
import {ReportFormat} from '../../../enums/ReportFormat';


export const modalOptions = {
  isLegacy: true,
  modalProps: {
    modalClass: '',
    useScrollWrapper: false,
  },
};

export function ExportModalHOC(WrappedComponent, options, listOptions) {
  /** @type {ReduxObservableListExportsActions} */
  const actions = options.actions;
  const logger = options.logger;

  if (!actions)
    throw new Error('ExportModalHOC missing required actions');

  if (!logger)
    throw new Error('ExportModalHOC missing required logger');

  return class ExportModalHOCComponent extends Component {
    constructor(props) {
      super(props);

      this.handleChangeFormatXlsx = this.handleChangeFormatXlsx.bind(this);
      this.handleChangeFormatCsv = this.handleChangeFormatCsv.bind(this);
    }

    static handleDownload(e) {
      ExportModalHOC.dependencies.$ngRedux.dispatch(actions.sendRequest());
    }

    handleChangeFormatXlsx() {
      this.handleChangeFormat(ReportFormat.XLSX);
    }

    handleChangeFormatCsv() {
      this.handleChangeFormat(ReportFormat.CSV);
    }

    handleChangeFormat(format) {
      if (this.props.format !== format) {
        ExportModalHOCComponent.updateFilterData({
          format,
        });
      }
    }

    render() {
      // TODO: provide relevant props, state (if any), and bound event handlers to appropriate components
      return (
        <WrappedComponent
          onChangeFormatXlsx={this.handleChangeFormatXlsx}
          onChangeFormatCsv={this.handleChangeFormatCsv}
          onReset={ExportModalHOCComponent.handleReset}
          onDownload={ExportModalHOCComponent.handleDownload}

          {...this.props}
        />
      );
    }

    /**
     * @param {ReduxListExports~FilterData} payload
     */
    static updateFilterData(payload) {
      ExportModalHOC.dependencies.$ngRedux.dispatch(actions.applyFilter(payload));
    }

    static handleReset(e) {
      e.preventDefault();
      e.stopPropagation();
      ExportModalHOCComponent.updateFilterData({
        format: ReportFormat.XLSX,
        ...ExportModalHOCComponent.getDefaultFilterData(),
      });
    }

    static getDefaultFilterData() {
      if (options.useListStateFilter) {
        const rootState = ExportModalHOC.dependencies.$ngRedux.getState();
        const listState = options.getState(rootState);
        return getFilterDataFromListState(listOptions, listState);
      } else {
        return options.getDefaultFilterData();
      }
    }
  };
}

ExportModalHOC.$inject = [
  '$ngRedux',
];



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux-observable-list-exports/components/ExportModalHOC/ExportModalHOCComponent.js